function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* globals window, document */

import React, { useState, useEffect } from 'react';
import Icon from '../../Icon';
import { text } from '../../../styles/colors';
import { CrossIcon } from '../../Icons';
import { Wrapper, CloseIconWrapper, ScrollableContent, Frame, preventScroll, SLIDE_ANIMATION_DURATION } from './style';
var content = /*#__PURE__*/React.createRef();
var Content = function Content(props) {
  var animation = props.animation,
    withOutsideClose = props.withOutsideClose,
    onClose = props.onClose,
    children = props.children,
    showCloseIcon = props.showCloseIcon,
    maxWidth = props.maxWidth,
    withFrame = props.withFrame;
  var _document = document,
    body = _document.body;
  var timeout;
  var scrollPosition = window.pageYOffset;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    closed = _useState2[0],
    setClosed = _useState2[1];
  var contentContainsTarget = function contentContainsTarget(target) {
    return content.current && content.current.contains(target);
  };
  var handleKeyPress = function handleKeyPress(e) {
    if (e.keyCode === 27) {
      handleClose(e);
    }
  };
  var handleClose = function handleClose(e) {
    e.stopPropagation();
    setClosed(true);
    if (onClose) {
      if (animation === 'slideFromRight') {
        timeout = setTimeout(function () {
          return onClose(e);
        }, SLIDE_ANIMATION_DURATION);
      } else {
        onClose(e);
      }
    }
  };
  useEffect(function () {
    body.style.cssText = preventScroll.toString();
    body.style.top = "-".concat(scrollPosition, "px");
    var handleOutsideClick = function handleOutsideClick(e) {
      if (withOutsideClose && !contentContainsTarget(e.target)) {
        handleClose(e);
      }
    };
    document.addEventListener('click', handleOutsideClick, true);
    document.addEventListener('keydown', handleKeyPress, true);
    return function () {
      // Scroll back to where you've been and remove preventScroll styles
      body.style.cssText = '';
      window.scrollTo(0, scrollPosition);
      document.removeEventListener('click', handleOutsideClick, true);
      document.removeEventListener('keydown', handleKeyPress, true);
      if (timeout) clearTimeout(timeout);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/React.createElement(Wrapper, {
    closed: closed,
    animation: animation,
    maxWidth: maxWidth,
    ref: content
  }, showCloseIcon && /*#__PURE__*/React.createElement(CloseIconWrapper, {
    animation: animation,
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(Icon, {
    as: CrossIcon,
    color: text.white,
    size: "sz32"
  })), /*#__PURE__*/React.createElement(ScrollableContent, {
    animation: animation
  }, withFrame ? /*#__PURE__*/React.createElement(Frame, null, children) : children));
};
Content.defaultProps = {
  animation: 'fadeIn',
  withFrame: true,
  showCloseIcon: true
};
Content.displayName = 'Content';
export default Content;